<template>
  <span :class="variantClass" class="inline-flex items-center gap-x-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset">
    <slot name="icon" />
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import type { BadgeProps } from 'types/section'

const { variant = 'neutral' } = defineProps<BadgeProps>()

const variantClass = computed(() => {
  if (variant === 'neutral') return 'bg-gray-50 text-gray-700 ring-gray-200'
  if (variant === 'success') return 'bg-emerald-50 text-emerald-700 ring-emerald-200'
  return 'bg-brand-50 text-brand-700 ring-brand-200'
})
</script>
